import React, { useState, useEffect } from 'react';
import { API } from '../../utils/api';

const SearchStatsPanel = ({
  searchResults,
  filteredMapResults,
  mapResults,
  categories,
  filteredResults,
  selectedCategories,
  filterInfo,
  aggregation,
  token
}) => {
  const [dbTotal, setDbTotal] = useState(null);

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/ultimate-search/stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => setDbTotal(d.total_results))
      .catch(() => {});
  }, [token, searchResults.length]);

  return (
    <div style={{
      flex: 1,
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(253, 251, 247, 0.9))',
      borderRadius: 12,
      border: '1px solid rgba(252, 211, 77, 0.3)',
      padding: 20,
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
      maxHeight: 400,
      overflowY: 'auto'
    }}>
      <h4 style={{ color: '#047857', margin: 0, fontSize: '1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
        📊 Search Statistics
      </h4>

      {/* Quick Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <div style={{
          background: 'rgba(16, 185, 129, 0.15)',
          borderRadius: 8,
          padding: 12,
          border: '1px solid rgba(16, 185, 129, 0.3)'
        }}>
          <div style={{ color: '#10b981', fontSize: '1.5rem', fontWeight: 700 }}>{dbTotal !== null ? dbTotal : (filterInfo?.total || mapResults.length || searchResults.length)}</div>
          <div style={{ color: '#71717a', fontSize: '0.75rem' }}>Total URLs in DB</div>
        </div>
        <div style={{
          background: 'rgba(245, 158, 11, 0.15)',
          borderRadius: 8,
          padding: 12,
          border: '1px solid rgba(245, 158, 11, 0.3)'
        }}>
          <div style={{ color: '#3b82f6', fontSize: '1.5rem', fontWeight: 700 }}>{filteredMapResults.length}</div>
          <div style={{ color: '#71717a', fontSize: '0.75rem' }}>On Map{mapResults.length !== filteredMapResults.length ? ` (${mapResults.length} total)` : ''}</div>
        </div>
        <div style={{
          background: 'rgba(253, 230, 138, 0.15)',
          borderRadius: 8,
          padding: 12,
          border: '1px solid rgba(253, 230, 138, 0.3)'
        }}>
          <div style={{ color: '#047857', fontSize: '1.5rem', fontWeight: 700 }}>{categories.length}</div>
          <div style={{ color: '#71717a', fontSize: '0.75rem' }}>Categories</div>
        </div>
        <div style={{
          background: 'rgba(245, 158, 11, 0.15)',
          borderRadius: 8,
          padding: 12,
          border: '1px solid rgba(245, 158, 11, 0.3)'
        }}>
          <div style={{ color: '#f59e0b', fontSize: '1.5rem', fontWeight: 700 }}>{filteredResults.length}</div>
          <div style={{ color: '#71717a', fontSize: '0.75rem' }}>Filtered</div>
        </div>
      </div>

      {/* Filter Status */}
      <div style={{
        background: 'rgba(252, 211, 77, 0.1)',
        borderRadius: 8,
        padding: 12,
        border: '1px solid rgba(252, 211, 77, 0.2)'
      }}>
        <div style={{ color: '#047857', fontSize: '0.85rem', fontWeight: 600, marginBottom: 5 }}>
          {filterInfo.filter_applied ? '🎯 Filters Active' : '📋 All Results'}
        </div>
        <div style={{ color: '#71717a', fontSize: '0.75rem' }}>
          {selectedCategories.length > 0
            ? `${selectedCategories.length} categories selected`
            : 'No category filter applied'}
        </div>
      </div>

      {/* Aggregation Mode */}
      <div style={{
        background: 'rgba(6, 182, 212, 0.1)',
        borderRadius: 8,
        padding: 12,
        border: '1px solid rgba(6, 182, 212, 0.2)'
      }}>
        <div style={{ color: '#06b6d4', fontSize: '0.85rem', fontWeight: 600, marginBottom: 5 }}>
          🔗 Mode: {aggregation.toUpperCase().replace('_', '/')}
        </div>
        <div style={{ color: '#71717a', fontSize: '0.75rem' }}>
          {aggregation === 'and' ? 'Must match ALL categories' :
           aggregation === 'or' ? 'Match ANY category' :
           'Smart matching mode'}
        </div>
      </div>
    </div>
  );
};

export default SearchStatsPanel;
